import React from "react";
import { BOT_CONFIGURATION_SUMMARY_ID } from "testIds";
import BotConfigurationSummary from "features/bots/BotDrawer/BotSummary";
import Modal from "common/Modal/Modal";
import { BotConfigurationModalProps } from "@shared/features/bots/types";
import HighlightedText from "common/Text/HighlightedText";
import Flex from "common/Boxes/Flex";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import BottomDrawer from "common/Drawers/BottomDrawer.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const BotConfigurationModal = ({
  bot,
  closeModal,
  open,
  isBulkEdit,
  showAmount,
  title: propsTitle,
  isChannelConfiguration,
}: BotConfigurationModalProps) => {
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const title = propsTitle ?? t("bot_configuration.title");

  const content = (
    <div data-testid={BOT_CONFIGURATION_SUMMARY_ID}>
      {isChannelConfiguration && (
        <HighlightedText
          hideLine={true}
          style={{ padding: 12, marginBottom: 20 }}
        >
          <Flex $alignItems="flex-start">
            <InfoCircleOutlined
              style={{
                marginRight: 12,
                flex: "none",
                fontSize: 20,
                marginTop: 4,
              }}
            />
            <span style={{ flex: 1, display: "block" }}>
              {t("group_configuration.notice")}
            </span>
          </Flex>
        </HighlightedText>
      )}
      {bot && (
        <BotConfigurationSummary
          botData={bot}
          showAmount={isBulkEdit || showAmount}
          showAccount={isBulkEdit}
          showName={isBulkEdit}
          isChannelConfiguration={isChannelConfiguration}
        />
      )}
    </div>
  );

  if (isBottomNavigator) {
    return (
      <BottomDrawer
        title={title}
        content={content}
        open={open}
        onClose={closeModal}
        contentStyle={{ maxHeight: "70vh", overflowY: "auto" }}
        showClose={true}
      />
    );
  }

  return (
    <Modal
      onCancel={closeModal}
      open={open}
      title={title}
      styles={{
        body: {
          minHeight: 400,
          maxHeight: 600,
          overflow: "auto",
        },
      }}
      footer={null}
      zIndex={1600}
    >
      {content}
    </Modal>
  );
};

export default BotConfigurationModal;
